import { render, staticRenderFns } from "./RequestRoadsIntegration.vue?vue&type=template&id=5efbdea3&"
import script from "./RequestRoadsIntegration.vue?vue&type=script&lang=js&"
export * from "./RequestRoadsIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCardSection,QItem,QInput,QField,QTable,QTh,QTr,QTd} from 'quasar'
component.options.components = Object.assign({QCardSection,QItem,QInput,QField,QTable,QTh,QTr,QTd}, component.options.components || {})
